import React from "react";
import { NavLink } from "react-router-dom";
import { estEntreeActive } from "./visibiliteMenu";

// Une entrée du menu : icône + libellé (masqué visuellement en rail, gardé
// pour les lecteurs d'écran) + infobulle en rail. NavLink pose
// aria-current="page" sur la route active ; `data-priv` reste lu par RoleStyle.
const ElementMenu = ({ item, infobulle = false, sousEntree = false }) => (
  <li data-priv={item.dataPriv || undefined}>
    <NavLink
      to={item.path}
      isActive={(match, location) => estEntreeActive(item, location.pathname)}
      className={"menu-lateral__item" + (sousEntree ? " menu-lateral__item--sous" : "")}
    >
      <i className={`fa fa-${item.icon}`} aria-hidden="true" />
      <span className="menu-lateral__libelle">{item.name}</span>
      {infobulle && (
        <span className="menu-lateral__bulle" aria-hidden="true">
          {item.name}
        </span>
      )}
    </NavLink>
  </li>
);

export default ElementMenu;
